<template>
  <v-text-field
    v-model="tableSearchString"
    ref="search"
    :class="[
      'expandable-search',
      { closed: !isSearchOpen && !tableSearchString },
      {
        'has-text': tableSearchString,
      },
    ]"
    clearable
    dense
    outlined
    data-lpignore="true"
    autocomplete="new-password"
    prepend-inner-icon="mdi-magnify"
    @click:prepend-inner="maybeSearch"
    hide-details
    title="Hit Enter to search"
    @focus="isSearchOpen = true"
    @blur="isSearchOpen = false"
    @keydown.enter="search"
    @keydown.esc="tableSearchString = ''"
    @click:clear="clearSearch"
    v-tooltip="getTooltipHtml"
  />
</template>

<script>
import { Model } from '@vuex-orm/core'
import { mapFields } from 'vuex-map-fields'
export default {
  name: 'ManageBaseTableSearchBar',
  props: {
    Model: {
      type: Model,
      default: () => Model,
    },
  },
  computed: {
    ...mapFields('admin', ['tableSearchString', 'isSearchOpen']),
    getTooltipHtml() {
      const text = `For best results use full words or the first part of a word. Example: if searching for "Strawberry Tart", typing "berry" won't work, but "straw", "strawberry" or "tart" will find it.`
      return {
        content: `<div class='proxima--font'>${text}</div>`,
        html: true,
        placement: 'bottom',
        delay: {
          show: 700,
          hide: 0,
        },
      }
    },
  },
  created() {
    if (this.$route.query.q) {
      this.tableSearchString = this.$route.query.q
    }
  },
  methods: {
    search() {
      let routeQuery = { ...this.$route.query }
      routeQuery.q = this.tableSearchString
      if (routeQuery.hasOwnProperty('page')) {
        delete routeQuery.page
      }
      this.$router.push({
        ...this.$route,
        query: routeQuery,
      })
    }, // search
    clearSearch() {
      let routeQuery = { ...this.$route.query }
      delete routeQuery.q
      if (routeQuery.hasOwnProperty('page')) {
        delete routeQuery.page
      }
      this.$router.push({
        ...this.$route,
        query: routeQuery,
      })
    }, // clearSearch
    maybeSearch() {
      if (this.tableSearchString) {
        this.search()
      } else {
        this.isSearchOpen = !this.isSearchOpen
      }
    }, // maybeSearch
  },
  data() {
    return {}
  },
  watch: {
    isSearchOpen(isSearchOpen) {
      if (isSearchOpen) {
        this.$refs.search.focus()
      } else {
        this.$refs.search.blur()
      }
    },
  },
}
</script>

<style lang="scss">
.expandable-search {
  transition: max-width 0.3s;
  .v-input__slot {
    cursor: pointer !important;
    &:before,
    &:after {
      border-color: transparent !important;
    }
  }
  &.closed {
    max-width: 48px;
  }
  &.has-text {
    min-width: 100px;
  }
}
</style>
